import { useMemo } from 'react';

import { DEFAULT_NAMESPACE } from '../shared/constants';

import { Logger } from './Logger';

/**
 * React hook to access logger instance
 * @param namespace - Optional namespace for categorized logging
 * @returns Logger instance
 *
 * @example
 * // Basic usage
 * const logger = useLogger();
 * logger.info('Component mounted');
 *
 * @example
 * // With namespace
 * const logger = useLogger('PaymentPortal');
 * logger.info('Initiating payment'); // Logs will include [PaymentPortal] prefix
 */
export function useLogger(namespace = DEFAULT_NAMESPACE): Logger {
	return useMemo(() => {
		return Logger.getInstance(namespace);
	}, [namespace]);
}
